<template>
  <div class="emails-box">
    <div v-if="contacts.length > 0">
      <div v-for="(c, index) in contacts" :key="c.id">
        <p
          class="contact contact-email"
          v-if="index === 0"
          :class="{ 'primary-contact': c.is_primary }"
        >
          <span v-if="tagEmailColor === 'presets'">
<!--            <emails-reply :client="client"> </emails-reply>-->
            <email-pre-sets
              :client="client"
              @cancelOpenEmailReplayBox="openEmailReplayBox = false"
              :openEmailReplayBox="openEmailReplayBox"
              @emailsCountRelayClicked="openEmailsCountRelay"
            >
            </email-pre-sets>
            <span
              v-if="client.email_log.length > 0"
              class="calls-length"
              @mouseenter="showEmailsLogTable = true"
              @mouseleave="showEmailsLogTable = false"
              >{{ client.email_log.length }}
            </span>

            <img
                @mouseleave="showReEmail = false"
                @mouseenter="showReEmail = true"

              @click="openEmailsReplay"
              class="clickAble forEmailIcon"
              width="18"
              :src="'img/icons/' + icone"
            :class="{'redEnv' : icone === 'envelope.svg'}"
            /><span
              :class="{ 'fa-lg': c.is_primary }"
            >
            </span
          ></span>
<!--          <img-->
<!--              v-if="tagEmailColor === 'raw'"-->
<!--              @click="takeMeToTheIncomingTask"-->
<!--              class="clickAble forEmailIcon"-->
<!--              width="17"-->
<!--              :src="'img/icons/' + icone"-->
<!--              :class="{'redEnv' : icone === 'envelope.svg'}"-->

<!--          />-->
<!--          <span-->
<!--            :class="{ 'fa-lg': c.is_primary }"-->

<!--        ></span>-->
          <span v-if="tagEmailColor === 'raw'">
            <emails-reply
              :client="client"
              @click="[openEmailsCountRelay,emailHasBeenSeen()]"
              :openEmailsCountRelayBox="openEmailsCountRelayBox"
            >
            </emails-reply>
            <img
              @click="[openEmailsCountRelay(),emailHasBeenSeen()]"
              class="clickAble forEmailIcon"
              width="17"
              :src="'img/icons/' + icone"
              :class="{'redEnv' : icone === 'envelope.svg'}"

            /><span
              :class="{ 'fa-lg': c.is_primary }"

            ></span
          >
          </span>
          <img
              v-if="tagEmailColor === 'block'"
              class="clickAble forEmailIcon"
              width="17"
              :src="'img/icons/' + icone"
              :class="{'redEnv' : icone === 'envelope.svg'}"

          /><span
            :class="{ 'fa-lg': c.is_primary }"

        ></span
        >
<!--          @mouseenter="showFullEmail = true"-->
<!--          @mouseleave="showFullEmail = false"-->
          <span
            class="forEmail"

          >
            {{ c.contact_value | truncate(11) }}
          </span>
          <span class="align-the-num">
            <span
              class="emails-length"
              @mouseleave="showTable = false"
              @mouseenter="showTable = true"
              v-if="!expanded"
              href="javascript:void(0)"
              @click="$emit('edit')"
              >{{ contacts.length }}</span
            >
          </span>
        </p>
        <div v-if="showFullEmail" class="email-popup">
          {{ c.contact_value }}
        </div>
      </div>
    </div>
    <div v-else>
      No-Email
    </div>
    <div
      v-if="client.email_log.length > 0 && showEmailsLogTable"
      class="email-log-table"
    >
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr v-for="(item, idx) in client.email_log" :key="idx">
              <td>{{ item.created_at }}</td>
              <td>{{ item.user.full_name }}</td>
              <td>{{ item.contact_value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      v-if="showReEmail && client.email_log.length > 0"
      class="email-log-table"
    >
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr v-for="(item, idx) in client.email_log" :key="idx">
              <td v-show="item.preset_id === 80">{{ item.created_at }}</td>
              <td v-show="item.preset_id === 80">{{ item.user.full_name }}</td>
              <td v-show="item.preset_id === 80">You are can't be reached.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="showTable" class="emails-table">
      <div class="table-responsive">
        <table class="table">
          <!--          <thead>
                    <tr  class="bg-info">
                      <th>Primary</th>
                      <th class="th-emails">Contact Emails</th>
                    </tr>
                    </thead>-->
          <tbody>
            <tr v-for="(item, idx) in contacts" :key="idx">
              <td>
                {{ item.deposit_email == 1 ? "Deposits, " : "" }}
                {{ item.is_primary == 1 ? "Primary" : "" }}
              </td>
              <td class="td-emails">{{ item.contact_value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import EmailsReply from "../../clients_table.sub_feature.company/components/EmailsReply";
import EmailPreSets from "../../clients_table.sub_feature.company/components/EmailPreSets";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import vClickOutside from "v-click-outside";
import moment from "moment";
import apiClientCreator from "@/helpers/api/request";
export default {
  name: "client-emails",
  mixins: [UsersPermissionCheck],
  components: {
    EmailPreSets,
    EmailsReply
  },
  props: {
    contacts: {
      type: Array
    },
    client: {
      type: Object
    },
    changeAutoIcone: {
      type: Boolean
    },
    changeToNotReIcone: {
      type: Boolean
    }
  },

  data() {
    return {
      expanded: false,
      showTable: false,
      openEmailsCountRelayBox: false,
      openEmailReplayBox: false,
      tagEmailColor: '',
      showEmailsLogTable: false,
      icone: "",
      showReEmail: false,
      showFullEmail: false,
    };
  },
  watch: {
    changeToNotReIcone: function() {
      if (!this.changeToNotReIcone) {
        this.icone = "gmail.svg";
      }
    },
    changeAutoIcone: function() {
      if (this.changeAutoIcone) {
        this.icone = "autoEmailSent.svg";
      }
    },


  },
  mounted() {

    // if (this.client.email_log.length > 0) {
    //   if (this.client.email_log[0].preset_id === 80) {
    //     this.icone = "autoEmailSent.svg";
    //   } else {
    //     this.icone = "gmail.svg";
    //   }
    // } else {
    //   this.icone = "gmail.svg";
    // }

  },
  created() {

    if((this.client.email_log.length >0 && this.client.email_replays.length === 0 )) {
      this.icone = "envelope.svg";
      this.tagEmailColor ='block';
    }else if(this.client.email_log.length >0 && this.client.email_replays.length > 0 && this.checkIfAllEmailsBeenReviewed(this.client.email_replays) || this.client.email_log.length !== this.client.email_replays.length){
      this.icone = "unEmail.png";
      this.tagEmailColor ='raw';
    }else {
      this.icone = "gmail.svg";
      this.tagEmailColor ='presets';
    }

    // console.log(this.client.email_replays);
  },
  methods: {
    checkIfAllEmailsBeenReviewed(emailRep){
      let flag = false;
      if(emailRep.length > 0){
       emailRep.map(email =>{
        if(email.email_review == 0){
          flag = true;
        }else {
          flag = false;
        }

      })
      }else {
        flag = false;
      }
      return flag;
    },
    emailHasBeenSeen(){
      let hasntReviewed;
      if(this.client.email_replays.length > 0){
        this.client.email_replays.map(email=>{
          if(email.email_review == 0){
            hasntReviewed =email;
            const sendEmailReply = apiClientCreator(`client/email/seen/${this.client.id}`);
            sendEmailReply
                .post("", {
                  emailSeen : 1
                })
                .then(a => {
                  // console.log(a+'hello');
                });
          }
        })
      }

    },
    takeMeToTheIncomingTask(){
      let hasntReviewed;
      if(this.client.email_replays.length > 0){
        this.client.email_replays.map(email=>{
          if(email.email_review == 0){
            hasntReviewed =email;
            const sendEmailReply = apiClientCreator(`client/email/seen/${this.client.id}`);
            sendEmailReply
                .post("", {
                  emailSeen : 1
                })
                .then(a => {
                  // console.log(a+'hello');
                });
          }
        })
      }

      this.$store.commit("clients/setSearchByTaskId",hasntReviewed.task_id);
      if (this.$route.name !== "Tasks") this.$router.push("/tasks");
    // if(this.client.email_replays[0].task_id){
    //   this.$store.commit("clients/setSearchByTaskId",this.client.email_replays[0].task_id);
    //   if (this.$route.name !== "Tasks") this.$router.push("/tasks");
    // }

    },
    outClose(){
      this.openEmailReplayBox = !this.openEmailReplayBox;
    },
    openEmailsCountRelay() {
      this.openEmailsCountRelayBox = true;
    },
    // openEmailsCountRelay() {
    //   this.openEmailsCountRelayBox = true;
    // },

    openEmailsReplay() {
      // this.CheckUserPermission([1, 2, 12]) &&
      if ( this.icone !== "envelope.svg") {
        this.openEmailReplayBox = !this.openEmailReplayBox;
      }
      // this.$emit("clicked");
    }
    // openReplay() {
    //   this.openEmailReplayBox = true;
    // }
  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
  font-size: 13px;
}

.emails-box {
  position: relative;
  /*!*margin-left: 5px;*!*/
  /*box-shadow: inset 1px 1px 5px 3px #00000010;*/
  /*padding-right: 7px;*/
  /*padding-left: 7px;*/
  /*padding-top: 3px;*/
  /*min-height: 27px;*/
}

.emails-length {
  cursor: pointer;
  font-size: 12px !important;
  font-weight: 400;
  /*border-radius: 3px;*/
}

.emails-table {
  position: absolute;
  top: 20px;
  right: -2px;
  z-index: 10001;
  width: max-content;
  margin-bottom: 0px;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #4d4f50;
  font-family: Montserrat;
}
.email-log-table {
  position: absolute;
  top: 24px;
  left: -10px;
  z-index: 10000;
  width: max-content;
  margin-bottom: 0px;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat;
}
.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}
.clickAble {
  cursor: pointer;
  margin-left: 4%;
}
.calls-length {
  font-size: 9px;
  color: #0d6aad;
  cursor: pointer;
  font-weight: 800;
}
.contact-email {
  /*text-transform: capitalize;*/
  cursor: pointer;
}
.forEmailIcon {
  transition: 0.5s ease-in-out;
}
.forEmailIcon:hover {
  transform: scale(1.1);
  transition: 0.5s;
}
.emails-box div span {
  font-size: 13px;
}
.align-the-num {
  float: right;
  /*border: 1px solid #af5656;*/
  /*padding: 5px;*/
  /*border-radius: 4px;*/
}
.email-popup {
  position: absolute;
  padding: 8px;
  top: 24px;
  right: 0px;
  z-index: 10001;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #4d4f50;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-family: Montserrat;
  width: max-content;
}
</style>
